import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Grid,
  Box,
  TextField,
  MenuItem,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  TableBody,
  useMediaQuery,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import apiRequest from "../../functions/api";
import { useTheme } from "@mui/material/styles";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import { DateTextField } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import Layout from "../shared/components/LayoutComponent";
import StrassenAutocomplete from "../StrassenAutocomplete/StrassenAutocomplete";
import { CheckBox, ContentCopy, DeleteOutline } from "@mui/icons-material";
import TelephoneInput from "../shared/components/TelephoneInput";
import { useConfirm } from "../../context/confirm-context";

function MasterNotkontakt(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [msgbox, setMsgBox] = useState(false);
  const { accessToken, client, bearbeitung, daten, setReload, reloadDaten } = props;
  const [stateReload, setStateReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [issending, setIsSending] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorFelder, setErrorFelder] = useState([]);

  const [editedKontakt, setEditedKontakt] = useState({});
  const [personInformiert, setPersonInformiert] = useState(false);
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const confirm = useConfirm();

  const daten_speichern = () => {
    if (!personInformiert){
      showErrorMessage("Bitte bestätigen Sie, dass Sie die betroffene Person informiert haben!")
      return
    }
    const requiredFields = ["name", "beziehung"];
    const missingFields = requiredFields.filter((field) => editedKontakt?.[field] === "");

    if (missingFields.length > 0) {
      setErrorFelder(missingFields);
      return;
    }

    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "SPEICHER_NOTFALLKONTAKT",
      daten: editedKontakt,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, speichercb, errorCb);
  };
  const deleteAnsprechpartner = () => {
    confirm({
      text: "Sind Sie sicher, dass Sie diesen Notfallkontakt löschen möchten ?",
      title: "Löschen",
      buttons: "YESNO",
    })
      .then(() => {
        setIsLoading(true);
        const payload = {
          mandant: client,
          program: "LWEB02",
          statement: "NOTFALLKONTAKT_ENTFERNEN",
          daten: editedKontakt,
        };
        const headers = {
          Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, deleteCb, errorCb);
      })
      .catch((antwort) => {});
  };
  const deleteCb = (response) => {
    if (response.status === 200) {
      if (response.data.message === "Ok") {
        // navigate(-1);
        showSuccessMessage(t("Notfallkontakt gelöscht"));
        setDialogOpen(false);

        reloadDaten();
      } else {
        showErrorMessage(response.data.message);
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const speichercb = (response) => {
    setPersonInformiert(false)
    if (response.status === 200) {
      if (response.data.message === "Ok") {
        // navigate(-1);
        showSuccessMessage(t("Änderungen gespeichert"));
        setDialogOpen(false);
        reloadDaten();
      } else {
        showErrorMessage(response.data.message);
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const errorCb = () => {
    setPersonInformiert(false)
    setIsSending(false);
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung"));
  };

  const messageBoxResult = (result) => {
    if (result === "NO") {
      setDialogOpen(false);
      setStateReload(!stateReload);
      // HoleDaten()
    }
    setMsgBox(false);
  };
  const getLenNoSpaces = (str) => {
    return str?.replace(/\s+/g, "").length;
  };
  if (msgbox && dialogOpen) {
    return (
      <MessageBox
        open={msgbox}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={["Wollen Sie diese Änderung überschreiben ?"]}
        title={t("Es ist bereits eine Adressänderung vorhanden")}
        onClose={() => setMsgBox(false)}
      />
    );
  }

  if (isLoading) {
    return <LoadingComponent />;
  }
  const dialogClose = () => {
    setEditedKontakt({});
    setDialogOpen(false);
    setPersonInformiert(false)
  };

  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    showSuccessMessage("Kopieren erfolgreich");
  };
  return (
    <Grid item xs={12}>
      <Paper>
        {daten?.beantragt?.status && <></>}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow key="adressdaten">
                <TableCell colSpan={2}>
                  <Typography>{t("1. Notfallkontakt")}</Typography>
                </TableCell>

                <TableCell align="right">
                  {bearbeitung && (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();

                        if (daten.beantragt?.status && daten.beantragt.status !== "A") {
                          showErrorMessage(
                            t(
                              "Es ist bereits eine Änderung in Bearbeitung. Bitte warten Sie, bis diese übernommen wurde, bevor Sie einen neuen Änderungsantrag stellen",
                            ),
                          );
                        } else {
                          setDialogOpen(true);
                          setEditedKontakt({ nummer: "1", telefonnummer: daten.tel1, name: daten.name1, beziehung: daten.beziehung1 });
                        }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={"name1"}>
                <TableCell>
                  <Typography>{t("Name")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.name1}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.name1}</Typography>}
                </TableCell>
                <TableCell align="right">
                  {/* <IconButton color="primary" onClick={() => handleCopy(daten.name1)}>
                    <ContentCopy />
                  </IconButton> */}
                </TableCell>
              </TableRow>
              <TableRow key={"tel1"}>
                <TableCell>
                  <Typography>{t("Telefonnummer")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.tel1}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.tel1}</Typography>}
                </TableCell>
                <TableCell align="right">
                  <IconButton color="primary" onClick={() => handleCopy(daten.tel1)}>
                    <ContentCopy />
                  </IconButton>
                </TableCell>
              </TableRow>
              <TableRow key={"beziehung1"}>
                <TableCell>
                  <Typography>{t("Beziehung")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.beziehung1Text}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.beziehung1Text}</Typography>}
                </TableCell>
                <TableCell align="right">
                  {/* <IconButton color="primary" onClick={() => handleCopy(daten.name1)}>
                    <ContentCopy />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table>
            <TableHead>
              <TableRow key="adressdaten">
                <TableCell colSpan={2}>
                  <Typography>{t("2. Notfallkontakt")}</Typography>
                </TableCell>

                <TableCell align="right">
                  {bearbeitung && (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();

                        if (daten.beantragt?.status && daten.beantragt.status !== "A") {
                          showErrorMessage(
                            t(
                              "Es ist bereits eine Änderung in Bearbeitung. Bitte warten Sie, bis diese übernommen wurde, bevor Sie einen neuen Änderungsantrag stellen",
                            ),
                          );
                        } else {
                          setDialogOpen(true);
                          setEditedKontakt({ nummer: "2", telefonnummer: daten.tel2, name: daten.name2, beziehung: daten.beziehung2 });
                        }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={"name2"}>
                <TableCell>
                  <Typography>{t("Name")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.name2}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.name2}</Typography>}
                </TableCell>
                <TableCell align="right">
                  {/* <IconButton color="primary" onClick={() => handleCopy(daten.name2)}>
                    <ContentCopy />
                  </IconButton> */}
                </TableCell>
              </TableRow>
              <TableRow key={"tel2"}>
                <TableCell>
                  <Typography>{t("Telefonnummer")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.tel2}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.tel2}</Typography>}
                </TableCell>
                <TableCell align="right">
                  <IconButton color="primary" disabled={daten.tel2?.length === 0} onClick={() => handleCopy(daten.tel2)}>
                    <ContentCopy />
                  </IconButton>
                </TableCell>
              </TableRow>
              <TableRow key={"beziehung2"}>
                <TableCell>
                  <Typography>{t("Beziehung")}</Typography>
                  {fullScreen && <Typography variant="body2">{daten.beziehung2Text}</Typography>}
                </TableCell>
                <TableCell width="125%" align="right">
                  {!fullScreen && <Typography variant="body2">{daten.beziehung2Text}</Typography>}
                </TableCell>
                <TableCell align="right">
                  {/* <IconButton color="primary" onClick={() => handleCopy(daten.name2)}>
                    <ContentCopy />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          sx={{ "& .MuiDialog-paper": { width: "70%", maxHeight: 800 } }}
          maxWidth="md"
          open={dialogOpen}
          fullWidth={fullScreen}
          onClose={() => dialogClose()}
        >
          <DialogTitle sx={{ width: "80%" }}>{editedKontakt?.nummer + ". " + t("Notfallkontakt bearbeiten")}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => deleteAnsprechpartner()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <DeleteOutline />
          </IconButton>
          <DialogContent dividers>
            <Layout fullWidth>
              <Backdrop
                open={issending}
                style={{
                  color: theme.palette.common.white,
                  zIndex: theme.zIndex.drawer + 1,
                }}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <TextField
                error={errorFelder.includes("name")}
                fullWidth
                value={editedKontakt?.name}
                onChange={(e) => setEditedKontakt({ ...editedKontakt, name: e.target.value })}
                label="Name*"
                margin="normal"
              />
              <Box sx={{ mt: 1 }} />
              <TelephoneInput
                label="Telefonnummer"
                value={editedKontakt?.telefonnummer}
                onChange={(e) => setEditedKontakt({ ...editedKontakt, telefonnummer: e })}
                // onChange={(e)=>console.log(e)}
              />
              {/* <TextField
                fullWidth
                value={editedKontakt?.telefonnummer}
                onChange={(e) => setEditedKontakt({ ...editedKontakt, telefonnummer: e.target.value })}
                label="Telefonnumer"
                margin="normal"
              /> */}
              <Box sx={{ mt: 1 }} />
              <TextField
                error={errorFelder.includes("beziehung")}
                fullWidth
                select
                value={editedKontakt?.beziehung}
                onChange={(e) => setEditedKontakt({ ...editedKontakt, beziehung: e.target.value })}
                label="Beziehung*"
                margin="normal"
              >
                {daten?.bezieh?.options?.map((option) => (
                  <MenuItem key={option.key} value={option.key}>
                    {option.value}
                  </MenuItem>
                ))}
              </TextField>

              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={personInformiert} onChange={(e)=>setPersonInformiert(e.target.checked)} />}
                  label="Hiermit bestätige ich, dass ich diesen Notfallkontakt über die Nennung informiert habe."
                />
              </FormGroup>
            </Layout>
          </DialogContent>
          <DialogActions>
            {/* <Box ml={1} alignItems={"start"}  >
              <Button color="primary" variant="text" fullWidth onClick={() => dialogClose()}>
                {"Zurück"}
              </Button>
            </Box>    */}
            <Box ml={1}>
              <Button color="primary" variant="text" fullWidth onClick={() => dialogClose()}>
                {"Zurück"}
              </Button>
            </Box>
            <Box ml={1}>
              <Button variant="contained" color="primary" fullWidth onClick={() => daten_speichern()}>
                {"Speichern"}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Paper>
    </Grid>
  );
}
export default MasterNotkontakt;
